import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { PERMISSION } from '../store/actionTypes';

export const permission = createApi({
  reducerPath: PERMISSION,
  baseQuery,
  tagTypes: ['Permission'],
  endpoints: builder => ({
    getPermission: builder.query<
      { isValid: boolean },
      { slug: string; method: string; domain: string }
    >({
      query: variables => ({
        document: gql`
          query GetPermission($slug: String!, $method: String!, $domain: String!) {
            getPermission(slug: $slug, method: $method, domain: $domain) {
              isValid
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: { getPermission: { isValid: boolean } }) =>
        response?.getPermission,
      providesTags: ['Permission'],
    }),
  }),
});

export const { useGetPermissionQuery } = permission;
